<template>
    <v-container fluid style="color: grey" class="policeLato">
      <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
      <section v-if="isDesktop()">
        <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
          <p class="paralax-cover-image-text">
          <div class="content_home" style="z-index: 1!important;">
            <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('politique_confidentialite.insurance_simply_label[0]') }}</span></h1>
            <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('politique_confidentialite.insurance_simply_label[1]') }}</span></h1>
          </div>
          </p>
        </div>
      </section>

      <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
      <section class="mt-5" v-if="isMobile()">
        <div class="paralax-cover-image_mobile has-background-dim_mobile">
          <p class="paralax-cover-image-text_mobile">
          <div class="content_home" style="z-index: 1!important;margin-top: 20%">
            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('politique_confidentialite.insurance_simply_label[0]') }}</span></h1>
            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('politique_confidentialite.insurance_simply_label[1]') }}</span></h1>
          </div>
          </p>
        </div>
      </section>

        <!--Notre histoire-->
        <!--Notre histoire-->
        <!--Notre histoire-->
        <v-layout row wrap pa-5 class="align-end justify-content-around">
            <v-flex xs12 sm12 md12 lg12 pa-2>
                <p class="headline font-weight-bold" style="text-align:center;color:#59595B">
                    {{ $t('politique_confidentialite.condition_legale_title') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 v-if="isDesktop()">
                <p class="headline text-assuraf pl-md-5 pt-3">
                    <i class="title-border"></i>{{ $t('politique_confidentialite.preambule_label') }}
                </p>
                
                <p class="text-justify subheading font-weight-regular">
                    <span>
                       {{ $t('politique_confidentialite.preambule_content[0]') }}
                    </span>
                    
                    <ul>
                        <br>
                        <a rel="noopener noreferrer" aria-label="generalite" title="generalite" href="#a1"><p><span>{{ $t('politique_confidentialite.annexe[0]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Société" title="Société" href="#a2"><p><span>{{ $t('politique_confidentialite.annexe[1]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Prestations" title="Prestations" href="#a3"><p><span>{{ $t('politique_confidentialite.annexe[2]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Terminologie" title="Terminologie" href="#a4"><p><span>{{ $t('politique_confidentialite.annexe[3]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Modalités" title="Modalités" href="#a5"><p><span>{{ $t('politique_confidentialite.annexe[4]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Paiement" title="Paiement" href="#a6"><p><span>{{ $t('politique_confidentialite.annexe[5]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Livraison" title="Livraison" href="#a7"><p><span>{{ $t('politique_confidentialite.annexe[6]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Conformité" title="Conformité" href="#a8"><p><span>{{ $t('politique_confidentialite.annexe[7]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Modalités" title="Modalités" href="#a9"><p><span>{{ $t('politique_confidentialite.annexe[8]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Réclamations" title="Réclamations" href="#a10"><p><span>{{ $t('politique_confidentialite.annexe[9]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Déclaration" title="Déclaration" href="#a11"><p><span>{{ $t('politique_confidentialite.annexe[10]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Archivage" title="Archivage" href="#a12"><p><span>{{ $t('politique_confidentialite.annexe[11]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="langue" title="langue" href="#a13"><p><span>{{ $t('politique_confidentialite.annexe[12]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="langue" title="langue" href="#a14"><p><span>{{ $t('politique_confidentialite.annexe[13]') }}</span></p></a>
                    </ul>
                </p>

            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 v-if="isMobile()">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.preambule_label') }}</p>
                <p class="text-justify subheading font-weight-regular">
                   <span>
                    {{ $t('politique_confidentialite.preambule_content[0]') }}
                   </span>
                    
                    <ul style="font-size: 13px;">
                        <br>
                       <a rel="noopener noreferrer" aria-label="generalite" title="generalite" href="#a1"><p><span>{{ $t('politique_confidentialite.annexe[0]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Société" title="Société" href="#a2"><p><span>{{ $t('politique_confidentialite.annexe[1]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Prestations" title="Prestations" href="#a3"><p><span>{{ $t('politique_confidentialite.annexe[2]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Terminologie" title="Terminologie" href="#a4"><p><span>{{ $t('politique_confidentialite.annexe[3]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Modalités" title="Modalités" href="#a5"><p><span>{{ $t('politique_confidentialite.annexe[4]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Paiement" title="Paiement" href="#a6"><p><span>{{ $t('politique_confidentialite.annexe[5]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Livraison" title="Livraison" href="#a7"><p><span>{{ $t('politique_confidentialite.annexe[6]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Conformité" title="Conformité" href="#a8"><p><span>{{ $t('politique_confidentialite.annexe[7]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Modalités" title="Modalités" href="#a9"><p><span>{{ $t('politique_confidentialite.annexe[8]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Réclamations" title="Réclamations" href="#a10"><p><span>{{ $t('politique_confidentialite.annexe[9]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Déclaration" title="Déclaration" href="#a11"><p><span>{{ $t('politique_confidentialite.annexe[10]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="Archivage" title="Archivage" href="#a12"><p><span>{{ $t('politique_confidentialite.annexe[11]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="langue" title="langue" href="#a13"><p><span>{{ $t('politique_confidentialite.annexe[12]') }}</span></p></a>
                        <a rel="noopener noreferrer" aria-label="langue" title="langue" href="#a14"><p><span>{{ $t('politique_confidentialite.annexe[13]') }}</span></p></a>
                    </ul>
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 id="a1">
                <p class="headline text-assuraf pl-md-5 pt-3">
                <i class="title-border"></i>{{ $t('politique_confidentialite.article_un_label') }}</p>

                <p class="text-justify subheading font-weight-regular">
                    {{ $t('politique_confidentialite.article_un_content[0]') }} <span>ASSURAF SAS</span> {{ $t('politique_confidentialite.article_un_content[1]') }} <a href="https://www.assuraf.com">www.assuraf.com</a> {{ $t('politique_confidentialite.article_un_content[2]') }}<br><br>
                    {{ $t('politique_confidentialite.article_un_content[3]') }} <a href="https://www.assuraf.com">www.assuraf.com</a> {{ $t('politique_confidentialite.article_un_content[4]') }}
                    <br><br>{{ $t('politique_confidentialite.article_un_content[5]') }} <span>ASSURAF </span> {{ $t('politique_confidentialite.article_un_content[6]') }}
                    <br><br>{{ $t('politique_confidentialite.article_un_content[7]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 id="a2">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_deux_label') }}</p>
                <p class="text-justify subheading font-weight-regular">
                    {{ $t('politique_confidentialite.article_deux_content[0]') }} <a href="https://www.assuraf.com">www.assuraf.com</a> {{ $t('politique_confidentialite.article_deux_content[1]') }} <span>ASSURAF SAS</span>, {{ $t('politique_confidentialite.article_deux_content[2]') }} <span>SN DKR 2018 B 27531</span> {{ $t('politique_confidentialite.article_deux_content[3]') }} <span>{{ $t('politique_confidentialite.article_deux_content[4]') }}</span>
                    {{ $t('politique_confidentialite.article_deux_content[5]') }}
                    <ul>
                        <li>{{ $t('politique_confidentialite.article_deux_content[6]') }} contact@assuraf.com</li>
                        <li>{{ $t('politique_confidentialite.article_deux_content[7]') }} +221 76 141 64 64</li>
                    </ul>
                    
                    {{ $t('politique_confidentialite.article_deux_content[8]') }} <br>
                    <span>2.1</span> {{ $t('politique_confidentialite.article_deux_content[9]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_deux_content[10]') }} <br>
                    <span>2.2</span> {{ $t('politique_confidentialite.article_deux_content[11]') }}
                </p>
            </v-flex>
             
            <v-flex xs12 sm12 md7 lg7 pa-2 id="a3">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_trois_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('politique_confidentialite.article_trois_content[0]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_trois_content[1]') }} <a href="https://www.assuraf.com">www.assuraf.com</a>.
                    {{ $t('politique_confidentialite.article_trois_content[2]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_trois_content[3]') }}
                    <span>ASSURAF</span> {{ $t('politique_confidentialite.article_trois_content[4]') }}<br><br>
                    <span>ASSURAF SAS</span> {{ $t('politique_confidentialite.article_trois_content[5]') }} <br>
                    <ul style="list-style:none">
                        <li>- {{ $t('politique_confidentialite.article_trois_content[6]') }}</li>
                        <li>- {{ $t('politique_confidentialite.article_trois_content[7]') }}</li>
                        <li>- {{ $t('politique_confidentialite.article_trois_content[8]') }}</li>
                        <li>- {{ $t('politique_confidentialite.article_trois_content[9]') }}</li>
                        <li>- {{ $t('politique_confidentialite.article_trois_content[10]') }}</li>
                    </ul> 
                </p>
            </v-flex>
            
            <v-flex xs12 sm12 md7 lg7 pa-2 id="a4">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_quatre_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    <ul style="list-style:none">
                        <li>« <span>{{ $t('politique_confidentialite.article_quatre_content[0]') }}</span> » {{ $t('politique_confidentialite.article_quatre_content[1]') }} <a href="https://www.assuraf.com">www.assuraf.com</a>, {{ $t('politique_confidentialite.article_quatre_content[2]') }}</li>
                        <li>« <span>{{ $t('politique_confidentialite.article_quatre_content[3]') }}</span> » {{ $t('politique_confidentialite.article_quatre_content[4]') }}</li>
                        <li>« <span>{{ $t('politique_confidentialite.article_quatre_content[5]') }}</span> » {{ $t('politique_confidentialite.article_quatre_content[6]') }}</li>
                        <li>« <span>{{ $t('politique_confidentialite.article_quatre_content[7]') }}</span> » {{ $t('politique_confidentialite.article_quatre_content[8]') }}</li>
                        <li>« <span>{{ $t('politique_confidentialite.article_quatre_content[9]') }}</span> » {{ $t('politique_confidentialite.article_quatre_content[10]') }}</li>
                        <li>« <span>{{ $t('politique_confidentialite.article_quatre_content[11]') }}</span> » {{ $t('politique_confidentialite.article_quatre_content[12]') }}</li>                        
                    </ul>
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 id="a5">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_cinq_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                {{ $t('politique_confidentialite.article_cinq_content[0]') }}<br><br>
                {{ $t('politique_confidentialite.article_cinq_content[1]') }}
                <ul>
                    <li>{{ $t('politique_confidentialite.article_cinq_content[2]') }}</li>
                    <li>{{ $t('politique_confidentialite.article_cinq_content[3]') }}</li>
                </ul>
                {{ $t('politique_confidentialite.article_cinq_content[4]') }} <span>+221 76 141 64 64</span> {{ $t('politique_confidentialite.article_cinq_content[5]') }} <br><br>
                <span>5.1</span> {{ $t('politique_confidentialite.article_cinq_content[6]') }} <br><br>
                <span>5.2</span> {{ $t('politique_confidentialite.article_cinq_content[7]') }}<br><br>
                <span>5.3</span> {{ $t('politique_confidentialite.article_cinq_content[8]') }} <br><br>
                <span>5.4</span> {{ $t('politique_confidentialite.article_cinq_content[9]') }} <span>ASSURAF </span> {{ $t('politique_confidentialite.article_cinq_content[10]') }}<br><br>
                <span>5.5</span> {{ $t('politique_confidentialite.article_cinq_content[11]') }} <br><br>
                <span>5.6</span> <span> ASSURAF</span> {{ $t('politique_confidentialite.article_cinq_content[12]') }} <span>ASSURAF</span>. <br><br>
                <span>5.7</span> <span> ASSURAF</span> {{ $t('politique_confidentialite.article_cinq_content[13]') }} <span>ASSURAF </span> {{ $t('politique_confidentialite.article_cinq_content[14]') }}<br><br>
                <span>5.8</span> <span> {{ $t('politique_confidentialite.article_cinq_content[15]') }}</span>
                {{ $t('politique_confidentialite.article_cinq_content[16]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 id="a6">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_six_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                {{ $t('politique_confidentialite.article_six_content[0]') }} <span>eConnect</span> {{ $t('politique_confidentialite.article_six_content[1]') }} <br><br>
                <span>6.1 {{ $t('politique_confidentialite.article_six_content[2]') }} eConnect</span> 
                {{ $t('politique_confidentialite.article_six_content[3]') }} <span>ASSURAF</span>.
                <br><br>{{ $t('politique_confidentialite.article_six_content[4]') }} <span>eConnect</span> {{ $t('politique_confidentialite.article_six_content[5]') }} <span>ASSURAF</span>.
                <br><br>{{ $t('politique_confidentialite.article_six_content[6]') }}
                <span>{{ $t('politique_confidentialite.article_six_content[7]') }}</span>
                {{ $t('politique_confidentialite.article_six_content[8]') }} <br><br>
                <span>6.3 {{ $t('politique_confidentialite.article_six_content[9]') }} eConnect</span><br>
                {{ $t('politique_confidentialite.article_six_content[10]') }} <br>
                {{ $t('politique_confidentialite.article_six_content[11]') }}<br><br>
                
                <span>6.4 {{ $t('politique_confidentialite.article_six_content[12]') }}</span><br>
                <span>ASSURAF</span> {{ $t('politique_confidentialite.article_six_content[13]') }}
                <br><br><span>ASSURAF</span> {{ $t('politique_confidentialite.article_six_content[14]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 id="a7">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_sept_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                   {{ $t('politique_confidentialite.article_sept_content[0]') }}
                   <ul style="list-style:none">
                       <li>- {{ $t('politique_confidentialite.article_sept_content[1]') }}</li>
                       <li>- {{ $t('politique_confidentialite.article_sept_content[2]') }}</li>
                       <li>- {{ $t('politique_confidentialite.article_sept_content[3]') }}</li>
                   </ul>
                    {{ $t('politique_confidentialite.article_sept_content[4]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 id="a8">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_huit_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    <span>8.1</span> {{ $t('politique_confidentialite.article_huit_content[0]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_huit_content[1]') }}
                    <span>ASSURAF</span> {{ $t('politique_confidentialite.article_huit_content[2]') }} <br>
                    <span>8.2</span> {{ $t('politique_confidentialite.article_huit_content[3]') }} +221 76 141 64 64.
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 id="a9">
                <p class="headline text-assuraf pl-md-5 pt-3">
                    <i class="title-border"></i>
                    {{ $t('politique_confidentialite.article_neuf_label') }}
                </p>

                <p class="text-justify subheading font-weight-normal">
                    {{ $t('politique_confidentialite.article_neuf_content[0]') }}
                    <br><br>{{ $t('politique_confidentialite.article_neuf_content[1]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_neuf_content[2]') }} <a href="mailto:contact@assuraf.com">contact@assuraf.com</a> {{ $t('politique_confidentialite.article_neuf_content[3]') }}
                    <br><br><span>ASSURAF</span> {{ $t('politique_confidentialite.article_neuf_content[4]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_neuf_content[5]') }}
                    <br><br>{{ $t('politique_confidentialite.article_neuf_content[6]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_neuf_content[7]') }}
                    <span>ASSURAF</span> {{ $t('politique_confidentialite.article_neuf_content[8]') }}<br><br> 
                    <span>9.1 – {{ $t('politique_confidentialite.article_neuf_content[9]') }}</span>  <br>
                    <span>9.1.1</span> {{ $t('politique_confidentialite.article_neuf_content[10]') }} <br>
                    <br><br><span>9.1.2</span> {{ $t('politique_confidentialite.article_neuf_content[11]') }}  <br>
                    <br><br><span>9.1.3</span> {{ $t('politique_confidentialite.article_neuf_content[12]') }} <br>
                    <br><br><span>9.2 {{ $t('politique_confidentialite.article_neuf_content[13]') }}</span> <br>
                    {{ $t('politique_confidentialite.article_neuf_content[14]') }} <br>
                    <br><br><span>9.3 {{ $t('politique_confidentialite.article_neuf_content[15]') }}</span> <br>
                    <br><br><span>9.3.1 ASSURAF</span> {{ $t('politique_confidentialite.article_neuf_content[16]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_neuf_content[17]') }} <br>
                    <br><br><span>9.3.2</span> {{ $t('politique_confidentialite.article_neuf_content[18]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_neuf_content[19]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_neuf_content[20]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 id="a10">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_dix_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                   <span>10.1</span> {{ $t('politique_confidentialite.article_dix_content[0]') }} <a href="mailto:contact@assuraf.com">contact@assuraf.com</a>
                   {{ $t('politique_confidentialite.article_dix_content[1]') }} 
                   <br><br><span>10.2</span> {{ $t('politique_confidentialite.article_dix_content[2]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_dix_content[3]') }} <span>ASSURAF</span> {{ $t('politique_confidentialite.article_dix_content[4]') }} <span>ASSURAF</span>, {{ $t('politique_confidentialite.article_dix_content[5]') }}<br><br>
                   <span>10.3</span> {{ $t('politique_confidentialite.article_dix_content[6]') }}, <span>ASSURAF</span> {{ $t('politique_confidentialite.article_dix_content[7]') }}
                </p>
            </v-flex>
             
            <v-flex xs12 sm12 md7 lg7 pa-2 id="a11">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_onze_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('politique_confidentialite.article_onze_content[0]') }} <span>ASSURAF</span>, {{ $t('politique_confidentialite.article_onze_content[1]') }}
                    <br><br>{{ $t('politique_confidentialite.article_onze_content[2]') }}
                    <span>ASSURAF</span> {{ $t('politique_confidentialite.article_onze_content[3]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 id="a12">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_douze_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('politique_confidentialite.article_douze_content[0]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2 id="a13">
                <p class="headline text-assuraf pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_treize_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('politique_confidentialite.article_treize_content[0]') }}
                </p>
            </v-flex>

             <v-flex xs12 sm12 md7 lg7 pa-2 id="a14">
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('politique_confidentialite.article_quatorze_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('politique_confidentialite.article_quatorze_content[0]') }} <a href="https://drive.google.com/file/d/10yCW8HdCzWeivWr_qKGCINA04nx11csP/view?usp=sharing" target="_blank"><span>{{ $t('politique_confidentialite.article_quatorze_content[1]') }}</span></a>, {{ $t('politique_confidentialite.article_quatorze_content[2]') }}<br><br>
                    {{ $t('politique_confidentialite.article_quatorze_content[3]') }} <br><br>
                    <ul style="list-style: disc;" class="ml-5">
                        <li>
                            {{ $t('politique_confidentialite.article_quatorze_content[4]') }}
                        </li>
                        <li>
                            {{ $t('politique_confidentialite.article_quatorze_content[5]') }}
                        </li>
                        <li>
                            {{ $t('politique_confidentialite.article_quatorze_content[6]') }}
                        </li>
                        <li>
                            {{ $t('politique_confidentialite.article_quatorze_content[7]') }} <span>{{ $t('politique_confidentialite.article_quatorze_content[8]') }}</span>, {{ $t('politique_confidentialite.article_quatorze_content[9]') }}
                        </li>
                    </ul>
                    <br>
                    {{ $t('politique_confidentialite.article_quatorze_content[10]') }} <br><br>
                     <ul style="list-style: disc;" class="ml-5">
                        <li>
                            {{ $t('politique_confidentialite.article_quatorze_content[11]') }}
                        </li>
                        <li>
                            {{ $t('politique_confidentialite.article_quatorze_content[12]') }}
                        </li>
                        <li>
                            {{ $t('politique_confidentialite.article_quatorze_content[13]') }}
                        </li>
                    </ul> <br>
                    {{ $t('politique_confidentialite.article_quatorze_content[14]') }} <span>{{ $t('politique_confidentialite.article_quatorze_content[15]') }}</span> {{ $t('politique_confidentialite.article_quatorze_content[16]') }}
                </p>
            </v-flex>
        </v-layout>

        <v-layout v-responsive.lg.xl>
            <!-- FAQ SECTION -->
            <FaqSection></FaqSection>
        </v-layout>

        <v-layout v-responsive.sm.xs>
            <!-- FAQ SECTION -->
            <FaqSectionMobile></FaqSectionMobile>
        </v-layout>
    </v-container>
</template>

<script>
    import FaqSection from './apropos_component/faq_section_desktop.vue'
    import FaqSectionMobile from './apropos_component/faq_section_mobile.vue'
    export default {
         components: {
            FaqSection,
            FaqSectionMobile
        },
        data () {
            return {
                description: 'Assuraf – Conditions de Souscription',
                HideDive:true,
                HideDive1:false,
                HideDive2:false,
                tabs: null,
                isHidden : true,
            }
        },
        metaInfo () {
            return {
                meta: [
                    { charset: 'utf-8' },
                    { name: 'keywords', content: 'conditions generales, CGV'},
                    { hid: 'description', name: 'description', content: this.description}
                ]
            }
        },

        methods :{
            isMobile: function(){
                if (screen.width <= 760) {
                    return true;
                }
                else {
                    return false;
                }
            },
            isDesktop: function(){
                if (screen.width > 760) {
                    return true;
                }
                else {
                    return false;
                }
            },
            tabengclicked : function () {
                this.HideDive=false;
                this.HideDive1=true;
                this.HideDive2=false;
            },
            tabinovclicked  : function () {
                this.HideDive=true;
                this.HideDive1=false;
                this.HideDive2=false;
            },
            tabresclicked : function () {
                this.HideDive=false;
                this.HideDive1=false;
                this.HideDive2=true;
            },
            toggle : function () {
                this.isHidden = !this.isHidden;
                if (this.isHidden===false){
                    this.$refs.btnPlus.$el.innerText = 'Afficher Moins';
                }else if (this.isHidden===true){
                    this.$refs.btnPlus.$el.innerText = 'Afficher Plus';
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/less/config";

    img{
        width: 100%;
        height: 300px;
    }
    .v-tabs__item--active{
        color: #ffa409;
    }
    .mamadou{
        width: 145px;
        height: 600px;
    }



    .article{
        padding: 1%;
        text-align: justify;
        font-size: 16px;
        line-height: 30px;
        font-family: "Myriad Pro Regular" !important;
    }
    .img-box{
        width: 10%;
        height: 15%;
    }
    .text-sm-left{
        font-family: "Open-Sans" !important;
        font-size: 16px;
        padding: 2%;
        width: 498px;
    }
    .text-xs-right{
        font-family: "Open-Sans" !important;
        padding: 2%;
        padding-top: -1000px;
        margin-left: 700px;
        font-size: 16px;
        width: 498px;
    }

    /*notre equipe*/
    h2 {
        color: #333;
        text-align: center;
        text-transform: uppercase;
        font-family: "Open-Sans", sans-serif;
        font-weight: bold;
        position: relative;
        margin: 30px 0 60px;
    }
    .valeur .description{
        font-size: 14px;
        color: #FFFFFF;
        line-height: 26px;
        text-indent: 30px;
        position: relative;
        margin-top: -29px;
        margin-left: 450px;
    }
    .primary--text{
        font-family: Myriad Pro;
        font-weight: bold;
        color: #000000;
        font-size: 20px;
        .v-tabs__item .v-tabs__item--active{
            color : black;
        }
    }
    .col-center {
        margin: 0 auto;
        float: none !important;
    }
    .carousel {
        margin: 50px auto;
        padding: 0 70px;
    }
    .carousel .item {
        color: #999;
        font-size: 14px;
        text-align: center;
        overflow: hidden;
        min-height: 290px;
    }
    .carousel .item .img-box {
        width: 175px;
        height: 175px;
        margin: 0 auto;
        padding: 5px;
        border: 1px solid #ddd;
        border-radius: 50%;
    }
    .carousel .img-box img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
    }
    .carousel .testimonial {
        padding: 30px 0 10px;
    }
    .carousel .overview {
        font-style: italic;
    }
    .carousel .overview b {
        text-transform: uppercase;
        color: #7AA641;
    }
    .carousel .carousel-control {
        width: 40px;
        height: 40px;
        margin-top: -20px;
        top: 50%;
        background: none;
    }
    .carousel-control i {
        font-size: 68px;
        line-height: 42px;
        position: absolute;
        display: inline-block;
        color: rgba(0, 0, 0, 0.8);
        text-shadow: 0 3px 3px #e6e6e6, 0 0 0 #000;
    }
    .carousel .carousel-indicators {
        bottom: -40px;
    }
    .carousel-indicators li, .carousel-indicators li.active {
        width: 10px;
        height: 10px;
        margin: 1px 3px;
        border-radius: 50%;
    }
    .carousel-indicators li {
        background: #999;
        border-color: transparent;
        box-shadow: inset 0 2px 1px rgba(0,0,0,0.2);
    }
    .carousel-indicators li.active {
        background: #555;
        box-shadow: inset 0 2px 1px rgba(0,0,0,0.2);
    }
        .text-assuraf{
        color: #ffa409;
    }
    .title-border{
        border-left: 5px solid #ffa409;
        padding-left: 0.6em;
        line-height: 0.5em;
    }   
    span{
        font-weight: bold
    }
    strong{
        color: rgb(101, 101, 235);
        font-family: 'Times New Roman', Times, serif
    }
    .policeLato {
      font-family: Lato, "Helvetica Neue", Arial, sans-serif;
    }
    .paralax-cover-image {
      background-image: url('../assets/img/assurance/cgv.jpg');
      position: relative;
      background-size: contain!important;
      background-position: 50%;
      min-height: 230px;
      width: 100%;
      margin: 0 0 0;
      display: flex;
      /*padding: 20px;*/
      align-items: center;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;

    }
    .paralax-cover-image p {
      color: rgb(255, 255, 255);
      font-size: 20px;
      font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
      color: #fff;
      font-size: 2em;
      line-height: 1.25;
      z-index: 1;
      margin-bottom: 0;
      max-width: 610px;
      text-align: center;
      margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
      background-attachment: fixed;
      background-position: 50% 40px;
    }



    .paralax-cover-image_mobile {
      background-image: url('../assets/img/assurance/cgv_mobile.jpg');
      position: relative;
      background-size: contain;
      background-position: 50%;
      min-height: 150px;
      width: 100%;
      margin: 0 0 0;
      display: flex;
      //padding: 20px;
      align-items: center;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
      color: rgb(255, 255, 255);
      font-size: 20px;
      font-weight: 300;
      padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
      color: #fff;
      font-size: 2em;
      line-height: 1.25;
      z-index: 1;
      margin-bottom: 0;
      max-width: 610px;
      text-align: center;
      margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
      background-attachment: fixed;
      background-position: 50% 50px;
    }
</style>
